export default __webpack_public_path__ + "static/media/pasadalogo.ab13296b.png";